import { useState } from 'react';
import emailjs from 'emailjs-com';
import './Contact.css'; 

function Contact() {
  const [formData, setFormData] = useState({ email: '', username: '', message: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs.send(
      'service_lbsw8dq',       
      'template_s1c27oo',        
      {
        from_email: formData.email,
        username: formData.username || 'N/A',
        message: formData.message,
      },
      'Cd3A0M_RS506IOTXF'    
    )
    .then(() => { alert('Message sent!'); setFormData({ email: '', username: '', message: '' });
    })
    .catch((error) => {
      console.error('EmailJS error:', error);
      alert('Failed to send message. Please try again.');
    });
  };

  return (
    <div className="contact-container">
      <h1>Contact Us</h1>
      <form onSubmit={handleSubmit} className="contact-form">
        <div className="form-group">
          <label>
            <span>Email Address*</span>
          </label>
          <input type="email" name="email" value={formData.email} onChange={handleChange} required />
        </div>

        <div className="form-group">
          <label>
            <span>Username</span>
          </label>
          <input type="text" name="username" value={formData.username} onChange={handleChange} />
        </div>

        <div className="form-group">
          <label>
            <span>Message*</span>
          </label>
          <textarea name="message" value={formData.message} onChange={handleChange} rows="5" required />
        </div>
        <p><em>* required fields</em></p>
        <button type="submit" className="submit-button">Submit</button>
      </form>
    </div>
  );
}

export default Contact;


